import type { LucideIcon } from 'lucide-react';
import {
  Home,
  FolderOpen,
  BarChart2,
  CalendarDays,
  MessageSquare,
  Inbox,
  Settings,
} from 'lucide-react';
import type { ActivePanelId } from '@/core/stores/ui.store';

export interface PanelConfig {
  id: ActivePanelId;
  icon: LucideIcon;
  labelKey: string;
}

export const panelConfig: PanelConfig[] = [
  { id: 'home', icon: Home, labelKey: 'layout:sidebar.rail.home' },
  { id: 'projects', icon: FolderOpen, labelKey: 'layout:sidebar.rail.projects' },
  { id: 'analytics', icon: BarChart2, labelKey: 'layout:sidebar.rail.analytics' },
  { id: 'calendar', icon: CalendarDays, labelKey: 'layout:sidebar.rail.calendar' },
  { id: 'messages', icon: MessageSquare, labelKey: 'layout:sidebar.rail.messages' },
  { id: 'inbox', icon: Inbox, labelKey: 'layout:sidebar.rail.inbox' },
  { id: 'settings', icon: Settings, labelKey: 'layout:sidebar.user.settings' },
];

export const getPanelConfig = (id: ActivePanelId): PanelConfig | undefined => {
  return panelConfig.find((panel) => panel.id === id);
};
